import { render, staticRenderFns } from "./PowerOfAttorneyTwoSignatories.vue?vue&type=template&id=6050c3ec&scoped=true&"
import script from "./PowerOfAttorneyTwoSignatories.vue?vue&type=script&lang=js&"
export * from "./PowerOfAttorneyTwoSignatories.vue?vue&type=script&lang=js&"
import style0 from "./PowerOfAttorneyTwoSignatories.vue?vue&type=style&index=0&id=6050c3ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6050c3ec",
  null
  
)

export default component.exports